import * as React from "react";
import * as RadixRadioGroup from "@radix-ui/react-radio-group";
import { cn } from "../../lib/utils";

export const RadioGroup = ({
  value,
  onValueChange,
  className,
  children,
  ...props
}: {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
  children: React.ReactNode;
  [key: string]: any;
}) => (
  <RadixRadioGroup.Root
    value={value}
    onValueChange={onValueChange}
    className={cn("flex flex-wrap gap-2", className)}
    {...props}
  >
    {children}
  </RadixRadioGroup.Root>
);

export const RadioGroupItem = ({
  value,
  label,
  className,
  ...props
}: {
  value: string;
  label: string;
  className?: string;
  [key: string]: any;
}) => (
  <RadixRadioGroup.Item
    value={value}
    className={cn(
      "flex items-center gap-2 px-3 py-1 rounded border border-gray-300 bg-white text-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary",
      "data-[state=checked]:border-black-500 data-[state=checked]:bg-red-50",
      className
    )}
    {...props}
  >
    <span>{label}</span>
  </RadixRadioGroup.Item>
);
